import type { EstimacionDelAlta } from '../api/tipos'

/**
 * Lo que el panel dice de los créditos que gasta la IA (plan del CMS dinámico §9), en llano y
 * en un sitio: la estimación del alta, el gasto del ciclo y cada llamada. Las cifras las da
 * el núcleo; aquí solo se escriben.
 */

/** «1 crédito», «12 créditos». */
export const creditosEnLlano = (n: number): string => `${n.toLocaleString('es')} ${n === 1 ? 'crédito' : 'créditos'}`

/** Cada paso de la IA del alta con lo que cuesta, como mucho; los que no están disponibles, dicho. */
export const lineasDeEstimacion = (e: Pick<EstimacionDelAlta, 'pasos'>): string[] =>
  e.pasos.map((p) => (p.disponible ? `${p.etiqueta}: unos ${creditosEnLlano(p.creditos)}` : `${p.etiqueta}: no disponible ahora (no se cobra)`))

/** La frase de la estimación: cuánto cuesta, cuánto hay y, si no llega, qué se puede hacer. */
export const textoDeEstimacion = (e: Pick<EstimacionDelAlta, 'alcanza' | 'saldo' | 'total'>): string =>
  e.total === 0
    ? 'Ahora mismo la IA no está disponible para el alta: la web se monta con la plantilla y los textos por rellenar, y no se cobra nada.'
    : e.alcanza
      ? `La IA escribirá los textos y afinará el diseño con unos ${creditosEnLlano(e.total)} como mucho; tienes ${creditosEnLlano(e.saldo)}. Se cobra lo que cueste de verdad, que suele ser menos.`
      : `Escribir los textos y afinar el diseño con IA cuesta unos ${creditosEnLlano(e.total)} y tienes ${creditosEnLlano(e.saldo)}. Consigue más créditos o sigue sin IA: los textos quedarán por rellenar para que los escribas tú y la web saldrá con el diseño de la plantilla y tus colores.`

/** Qué parte de los créditos del plan se ha gastado en el ciclo, de 0 a 100. Sin créditos del plan, `null`: no hay barra que pintar. */
export const porcentajeDelCiclo = (consumidos: number, delPlan: number): null | number => (delPlan > 0 ? Math.min(100, Math.round((Math.max(0, consumidos) / delPlan) * 100)) : null)
